import React from 'react';
import Heading from '../primitives/Heading';
import Typography from '../primitives/Typography';

export type SectionHeaderProps = {
  heading: React.ReactNode;
  description?: React.ReactNode;
  subheading?: string;
  className?: string;
};

const SectionHeader: React.FC<SectionHeaderProps> = ({ 
  heading, 
  description, 
  subheading,
  className = ''
}) => {
  return (
    <div className={["mb-6", className].join(' ')}>
      <Heading 
        as="h2" 
        size="lg" 
        className="mb-4"
      >
        {heading}
      </Heading>
      {description && (
        <Typography variant="body-lg" color="muted">
          {description}
        </Typography>
      )}
    </div>
  );
};

export default SectionHeader; 